import { inject } from '@angular/core';
import { CanActivateFn, CanDeactivateFn, Router } from '@angular/router';
import { INTERNAL_REDIRECT_STATE_KEY } from '@core/guards/valid-uuid-param.guard';

/**
 * Only allows entering the not-found page when redirected there by another guard
 * (e.g. validUuidParamGuard). Directly entering the URL redirects to the dashboard.
 */
export const notFoundAccessGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const navigationState = router.getCurrentNavigation()?.extras.state as Record<string, unknown> | undefined;
  const state = navigationState ?? (history.state as Record<string, unknown> | null);

  if (state?.[INTERNAL_REDIRECT_STATE_KEY]) {
    return true;
  }

  router.navigate(['/dashboard']);

  return false;
};

/**
 * Strips the internal-redirect marker from the not-found page's history entry when
 * navigating away, so that returning via the browser back button is blocked.
 * Refreshing the page while still on it is unaffected, since the marker is only
 * stripped on the way out.
 */
export const notFoundLeaveGuard: CanDeactivateFn<unknown> = (): boolean => {
  const strippedState = { ...(history.state as Record<string, unknown>), [INTERNAL_REDIRECT_STATE_KEY]: false };

  history.replaceState(strippedState, '', location.href);

  return true;
};
